import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import Header from "../HeaderComponent/Header";

import history from "../../auth/history";
import Footer from './../FooterComponent/FooterComponet';
import { v4 as uuidv4 } from 'uuid';
import { store } from "../../redux/store";
import { setAddBenefisciaryRequest, setAddBenefisciaryRequestUrl, setBeneCustomerId, setBeneSubDetails, setIfscCode, setSelectedBankId, setSelectedBankName } from "../../redux/misc-data/misc-data.action";
import { setSendersListDetails, setOtpResponse } from './../../redux/misc-data/misc-data.action';
import Select from 'react-select'
import HeaderCommon from './../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import { Link } from "react-router-dom";
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();
class AddBeneficiaryFinal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {

			benefisciaryName: '',
			benefisciaryMobile: '',
			phoneNo: this.props.phone,
			senderNameValue: '',
			selectedAccountNumber: '',
			confirmedAccountNumber: '',

			selectedBankName: this.props.selectedBankName,
			ifscCode: this.props.ifscCode,
			selectedBankId: this.props.selectedBankId,
			bankSelectMessage: '',
			bankDetails: [],

			errorMessage: '',
			checked: true,
			progress:''

		}
		this.handleCheck = this.handleCheck.bind(this)
	}


	handleCheck() {
		this.setState({
			checked: !this.state.checked
		})
	}

	addbenefisciaryName = (event) => {

		var beneName = '';

		var beneNameArray = event.target.value.split(" ");


		for (let i = 0; i < beneNameArray.length; i++) {
			beneName = beneName + " " + beneNameArray[i].toString().charAt(0).toUpperCase() +
				beneNameArray[i].substring(1, beneNameArray[i].length).toLowerCase();

		}
		console.log(beneName);
		beneName = beneName.trim();
		this.setState({
			benefisciaryName: beneName
		})
	}

	addbenefisciaryMobileNo = (event) => {
		this.setState({
			benefisciaryMobile: event.target.value
		})
	}


	enterIfscCode = (event) => {

		this.setState({
			ifscCode: event.target.value.toUpperCase()
		})


	}

	bankChange = (selected) => {

		store.dispatch(setSelectedBankName(selected.value));
		store.dispatch(setIfscCode(''));
		this.setState({
			selectedBankName: selected.value,
			ifscCode: ''
		})

		this.props.bankDetails.map(banks => {
			if (banks.name == selected.value) {

				if (banks.masterIfsc != null && banks.masterIfsc != '') {
					this.setState({
						ifscCode: banks.masterIfsc
					})
				}

				this.setState({
					selectedBankName: banks.name,
					selectedBankId: banks.id,

				})
				store.dispatch(setIfscCode(banks.masterIfsc != null ? banks.masterIfsc.toUpperCase() : ''));
				store.dispatch(setSelectedBankId(banks.id));

			}
		})
	}


	selectAccountNumber = (event) => {

		this.setState({
			selectedAccountNumber: event.target.value
		})
	}


	confirmAccountNumber = (event) => {
		this.setState({
			confirmedAccountNumber: event.target.value
		})
	}


	componentDidMount() {
		store.dispatch(setAddBenefisciaryRequest(''));
		// store.dispatch(setSelectedBankName(''));
		// store.dispatch(setIfscCode(''));
		// store.dispatch(setSelectedBankId(''));
		// store.dispatch(setBeneCustomerId(''));
	}
	componentWillUnmount() {
	}

	validateMobile = () => {
		if (this.state.benefisciaryMobile.length == 10 &&
			this.state.benefisciaryMobile >= 6000000000
			&& this.state.benefisciaryMobile <= 9999999999) {
			return true;

		} else {
			alert('Please enter valid mobile No');
			return false;
		}

	}

	validateIfscCode = () => {

		var ifscRegex = /^[A-Z]{4}[0][A-Z0-9]{6}$/;

		if (this.state.ifscCode != "") {
			if (!ifscRegex.test(this.state.ifscCode)) {
				alert('Please enter valid IFSC code');
				return false;
			}
			else {

				return true;
			}
		}
	}


	addBenefisciaryDetails = (event) => {

		event.preventDefault();

		this.setState({
			progress:'started'
		})


		console.log('values...' + this.props.selectedBankName + " " + JSON.stringify(this.props.selectSender));

		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo.id,
			'role': this.props.clientRole
		}


		var nameResult = this.validateName();
		var accountConfirm = (this.state.selectedAccountNumber == this.state.confirmedAccountNumber);
		var selectedAccountNumberLength = this.state.selectedAccountNumber.length;
		var confirmedAccountNumberLength = this.state.confirmedAccountNumber.length;
		var mobileValidation = this.validateMobile();

		var ifscCodeValidation = this.validateIfscCode();

		var accountLengthverification = false;
		var accountvalueValidation=false;


		if (
			selectedAccountNumberLength >= 9 && selectedAccountNumberLength <= 18
			&&
			confirmedAccountNumberLength >= 9 && confirmedAccountNumberLength <= 18
		) {
			accountLengthverification = true;
		}

		var count = 0;
		for (var i = 0; i <= this.state.selectedAccountNumber.length; i++) {
			var val = this.state.selectedAccountNumber[i];

			if (val== '0') {
				count++;
			}
		}

		if (count >= this.state.selectedAccountNumber.length) {
			accountvalueValidation = false;
		}else{
			accountvalueValidation = true;
		}

		var selectedBankName = '';
		var ifscCode = '';


		selectedBankName = this.state.selectedBankName == '' ? this.props.selectedBankName :
			this.state.selectedBankName;

		ifscCode = this.state.ifscCode == '' ? this.props.ifscCode :
			this.state.ifscCode;


		if (accountConfirm == true
			&& nameResult == true &&
			accountLengthverification == true
			&& selectedBankName != ''
			&& mobileValidation == true
			&& ifscCodeValidation == true
			&& accountvalueValidation==true) {

			const url = '/api/v1/dmt/beneficiary/add';

			const addBenefisciaryRequestHeader = {
				msgType: "ADD_BENEFICIARY",
				service: "DMT",
				src: "add-beneficiary",
				dst: "review-add-beneficiary",
				channel: "WHITELABEL",
				requesterId: this.props.clientRequesterId,
				requestId: uuidv4(),
				traceId: uuidv4(),
			}





			const bankAccountDetails = {
				bank: selectedBankName,
				branch: this.props.branchAddress,
				accNum: this.state.selectedAccountNumber,
				ifsc: ifscCode
			}

			console.log('bankAccountDetails' + JSON.stringify(bankAccountDetails));


			var sendermobile = '';
			sendermobile = this.props.selectSender.customer.mobile;
			var customerId = '';



			customerId = this.props.selectSender.customer.id;



			const beneficiary = {
				name: this.state.benefisciaryName,
				// mobile: this.props.selectSender.customer.mobile,
				mobile: this.state.benefisciaryMobile,
				email: "",
				account: bankAccountDetails,
				verified: this.state.checked,
				addedBy: sendermobile
			}



			const otp = {
				mobile: this.props.selectSender.customer.mobile,
				type: "ADD_DMT_BENEFICIARY"
			}



			const addBenefisciaryRequest = {
				header: addBenefisciaryRequestHeader,
				beneficiary: beneficiary,
				deviceInfo: this.props.deviceInfo,
				otp: otp,
				customerId: customerId
			}

			console.log('addBenefisciaryRequest..' + JSON.stringify(addBenefisciaryRequest));

			const otpUrl = "/api/v1/otp/generate";
			const generateOtprRequestHeader = {
				msgType: "GENERATE_OTP",
				service: "DMT",
				src: "add-benefisciary",
				dst: "review-benefisciary",
				channel: "WHITELABEL",
				requesterId: this.props.clientRequesterId,
				requestId: uuidv4(),
				traceId: uuidv4(),
			}

			const generateOtpRequest = {
				header: generateOtprRequestHeader,
				otpDetails: otp
			}

			httpClient.post(otpUrl, generateOtpRequest, { headers }
			).then((response) => {
				console.log('otp generate response' + JSON.stringify(response.data));
				this.setState({
					progress:'completed'
				})
				if (response.data.response.msg == 'SUCCESS') {
					store.dispatch(setAddBenefisciaryRequest(addBenefisciaryRequest));
					store.dispatch(setOtpResponse(response.data));
					store.dispatch(setAddBenefisciaryRequestUrl(url));


					var accno = addBenefisciaryRequest.beneficiary.account.accNum;
					var accnoMiddle = '';
					for (let i = 0; i < accno.length; i++) {
						accnoMiddle = accnoMiddle + 'x';
					}
					var accountNo = accno.substring(0, 2) + accnoMiddle.substring(2, accno.length - 2) +
						accno.substring(accno.length - 1, accno.length);

					var idvalue = this.props.selectSender.customer.kyc.id;
					var idmiddle = '';
					for (let i = 0; i < idvalue.length; i++) {
						idmiddle = idmiddle + 'x';
					}
					var govtIdvalue = idvalue.substring(0, 2) + idmiddle.substring(2, idvalue.length - 2) +
						idvalue.substring(idvalue.length - 1, idvalue.length);
					var benefisciarySubDetails = {
						benefisciaryName: addBenefisciaryRequest.beneficiary.name,
						bankName: selectedBankName,
						accountNumber: addBenefisciaryRequest.beneficiary.account.accNum,
						benefisciaryMobile: addBenefisciaryRequest.beneficiary.mobile,
						ifscCode: ifscCode,
						customerName: this.props.selectSender.customer.name,
						govtIdType: this.props.selectSender.customer.kyc.type.replace("-", " "),
						govtIdValue: this.props.selectSender.customer.kyc.id,
						senderMobile: this.props.selectSender.customer.mobile

					}

					console.log('benefisciarySubDetails...' + JSON.stringify(benefisciarySubDetails));

					store.dispatch(setBeneSubDetails(benefisciarySubDetails));

					var reviewAddBeneficiary = document.getElementById('reviewAddBeneficiary');
					reviewAddBeneficiary.click();
				} else {
					this.errorMessageCall(response.data.response.displayMsg);
				}
			}).catch(error => {
				this.setState({
					progress:'completed'
				})
				this.errorMessageCall('Something went wrong in otp generate,please try again later!');
				console.log(error);
				if (error.message.includes("401")) {
					tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
				}
			});

		}
		else {
			var accountConfirmMessage = "";
			this.setState({
				progress:'completed'
			})
			if (accountConfirm == false) {
				accountConfirmMessage = "Account number mismatched";
				this.errorMessageCall(accountConfirmMessage);
			}
			if (accountvalueValidation == false) {
				accountConfirmMessage = "Account number can not be 0 only";
				this.errorMessageCall(accountConfirmMessage);
			}
			if (selectedBankName == '') {
				accountConfirmMessage = "Please select a bank";
				this.errorMessageCall(accountConfirmMessage);
			}
			if (accountLengthverification == false) {
				accountConfirmMessage = "Account Number should be between 9-18";
				this.errorMessageCall(accountConfirmMessage);
			}
		}
	}

	errorMessageCall = (error) => {
		this.setState({
			errorMessage: error
		})
	}

	searchIfsc = () => {

		if (this.state.selectedBankName != '' ||
			this.props.selectedBankName != '' ||
			(this.state.selectedBankName != '' && this.props.selectedBankName != '')
		) {
			var searchIfscSuccess = document.getElementById('searchIfscSuccess');
			searchIfscSuccess.click();;
		} else {
			this.errorMessageCall('Please select a bank');
			var searchIfscFailed = document.getElementById('searchIfscFailed');
			searchIfscFailed.click();
		}


	}




	validateName() {
		// var regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
		var regName = /^[a-zA-Z ]*$/;
		var name = this.state.benefisciaryName;

		var regexp = /\b[^\d\s]+\b/g;
		var count = 0;
		while (regexp.exec(name)) {
			++count;
		}

		var nameArray = name.split(" ");
		for (let i = 0; i < nameArray.length; i++) {
			if (nameArray[i].length <= 2) {
				alert('Each word in name should contains more than two characters and one space between them');
				return false;
			}
		}

		if (!regName.test(name)) {
			alert('Name should contains alphabets only');
			return false;
		} else if (count < 2) {
			alert('Please enter at least two words');
			return false;
		} else {
			return true;
		}
	}



	render() {
		console.log('sender data...' + JSON.stringify(this.props.selectSender));

		var searchableBankList = [];
		this.props.bankDetails.map(bank => {
			var stateVal = {
				value: '',
				label: ''
			}
			stateVal.value = bank.name;
			stateVal.label = bank.name;
			searchableBankList.push(stateVal);
		})

		return (

			<div>
				<HeaderCommon />
				<Menu />
				<div class="main">


					<div class="right-side">
						<div class="container-fluid">



							<div class="row">
								<div class="col-12">
									<div class="card-b">
										<div id="recenttxn">
											<div class="head">
												<h3>Add Beneficiary</h3>
												<Link to='/dmt'>
													<button class="dbbtn">Back</button>
												</Link>
												<Link to='/review-add-beneficiary'>
													<button id='reviewAddBeneficiary' hidden={true}>Back</button>
												</Link>

											</div>


											<form onSubmit={this.addBenefisciaryDetails}>
												<div class="dashform">
													<div class="row">
														{

															(this.state.selectedBankName != '') ?
																<div class="col-12 col-sm-6 col-xl-5">

																	<label for="bank">Bank Name</label>
																	<div class="form-floating">

																		<div class="form-floating">
																			<Select options={searchableBankList} class="form-control"
																				SelectContainer={true}
																				defaultValue={{ label: this.props.selectedBankName, value: this.props.selectedBankName }}
																				onChange={this.bankChange}
																			/>

																		</div>

																	</div>
																</div>
																:
																<div class="col-12 col-sm-6 col-xl-5">


																	<label for="bank">Bank Name</label>
																	<div class="form-floating">
																		<Select options={searchableBankList} class="form-control"
																			onChange={this.bankChange} required />

																	</div>
																</div>
														}

														{this.props.ifscCode != '' ?
															<div class="col-12 col-sm-6 col-xl-5">
																<div class="form-floating">

																	<input type="text" class="form-control" id="code"
																		value={this.state.ifscCode} readOnly>

																	</input>
																	<label for="code">IFSC Code</label>

																</div>
															</div>
															:
															<div class="col-12 col-sm-6 col-xl-5">
																<div class="form-floating">
																	{this.state.ifscCode == '' && this.state.ifscCode}
																	<input type="text" class="form-control" id="code"
																		onInput={(e) => e.target.value = e.target.value.slice(0, 11)}
																		placeholder="IFSC Code"
																		onChange={this.enterIfscCode}
																		value={this.state.ifscCode}
																		required />
																	<label for="code">IFSC Code</label>

																	<button class="lbbtn otpbtn" type="button" onClick={this.searchIfsc}
																	>Search</button>

																	<Link to='/search-ifsc'>
																		<button id='searchIfscSuccess' hidden={true}></button>
																	</Link>
																	<Link to='/add-beneficiary'>
																		<button id='searchIfscFailed' hidden={true}></button>
																	</Link>
																</div>
															</div>
														}




														<div class="col-12 col-sm-6 col-xl-5">
															<div class="form-floating">
																<input type="number" class="form-control" id="mobile"
																	placeholder="Mobile"
																	onInput={(e) => e.target.value = e.target.value.slice(0, 18)}
																	onChange={this.selectAccountNumber}
																	minLength={8}
																	required />
																<label for="mobile">Account Number</label>
															</div>
														</div>

														<div class="col-12 col-sm-6 col-xl-5">
															<div class="form-floating">
																<input type="number" class="form-control" id="txnid" placeholder="ID Number"
																	onInput={(e) => e.target.value = e.target.value.slice(0, 18)}
																	onChange={this.confirmAccountNumber}
																	minLength={8}
																	required />
																<label for="txnid">Confirm Account Number</label>
															</div>
														</div>

														<div class="col-12 col-sm-6 col-xl-5">
															<div class="form-floating">
																<input type="text" class="form-control" id="nmae"
																	placeholder="Sender Name"
																	onChange={this.addbenefisciaryName}
																	required />
																<label for="nmae">Beneficiary Name</label>
															</div>
														</div>


														<div class="col-12 col-sm-6 col-xl-5">
															<div class="form-floating">
																<input type="number" class="form-control" id="nmae"
																	placeholder="Bene Mobile No"
																	onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
																	onChange={this.addbenefisciaryMobileNo}
																	required />

																<label for="bmobi">Beneficiary Mobile No.</label>
															</div>
														</div>


														<div class="col-12">
															<div class="form-check">
																<input class="form-check-input" type="checkbox" value="selected"
																	id="flexCheckChecked"
																	// checked
																	defaultChecked={this.state.checked}
																	onChange={this.handleCheck}
																/>
																<label class="form-check-label" for="flexCheckChecked">
																	Sender wants to validate beneficiary details from bank and agrees to pay Rs. 5 for verification.
																</label>
															</div>
														</div>

														<div class="col-12">
															<button type="submit" class="btn btn-primary"
															disabled={this.state.progress=='started'?true:false}
															// onClick={this.benefisciary}
															>Continue</button>
														</div>

													</div>
												</div>
											</form>
											{this.state.errorMessage != '' &&
												<div class='valid-error'>{this.state.errorMessage}
												</div>}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer />
			</div>
		);
	}
}


const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, customerId, deviceInfo, addsenderRequest, bankDetails, selectedBankName,
			selecetdBankId,
			ifscCode, token, clientRole, clientRequesterId, agentInfo,
			selectSender, beneSubDetails, branchAddress, selecetedBankname,
			callBackUrl
		} }
) => ({
	errorMessage, loginErrorMessage, phone, customerId, deviceInfo, addsenderRequest, bankDetails,
	selectedBankName, selecetdBankId,
	ifscCode, token, clientRole, clientRequesterId, agentInfo,
	selectSender, beneSubDetails, branchAddress, selecetedBankname,
	callBackUrl
});

export default connect(mapStateToProps, null)(AddBeneficiaryFinal);
